import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-072ba808"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100 mt-5 friSepLine1" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"padding-top":"20px"} }, "Geolocation", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"padding-top":"20px"} }, "Alerts", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"padding-top":"20px"} }, "Camera", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notifications", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_ion_button, {
      onClick: _ctx.getCurrentPosition,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Get Current Location 33")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_3,
    _createVNode(_component_ion_button, {
      onClick: _ctx.alertApp,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("App")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_ion_button, {
      onClick: _ctx.alertLocal,
      class: "pfBtn-secondary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Mobile")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_ion_button, {
      onClick: _ctx.dialogApp,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Dialog")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_ion_button, {
      onClick: _ctx.toastApp,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("toast")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_4,
    _createVNode(_component_ion_button, {
      onClick: _ctx.takePicture,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Foto")
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.photo.src)
      ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_img, {
              src: _ctx.photo.src,
              class: _normalizeClass('photoImg')
            }, null, 8, ["src"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createVNode(_component_ion_input, {
      type: "phone",
      modelValue: _ctx.smsOptions.num,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.smsOptions.num) = $event)),
      placeholder: "Enter Number",
      style: {"border":"1px solid #fff","width":"50%","margin-left":"25%"}
    }, null, 8, ["modelValue"]),
    _createVNode(_component_ion_textarea, {
      placeholder: "Enter message",
      modelValue: _ctx.smsOptions.msg,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.smsOptions.msg) = $event)),
      style: {"border":"1px solid #fff","width":"60%","margin-left":"20%","min-height":"60px"}
    }, null, 8, ["modelValue"]),
    _hoisted_6,
    _createVNode(_component_ion_button, {
      onClick: _ctx.sendSms,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("SMS")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_ion_button, {
      onClick: _ctx.shareApp,
      class: "pfBtn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Share")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_ion_button, { class: "pfBtn-secondary" }, {
      default: _withCtx(() => [
        _createTextVNode("Email")
      ]),
      _: 1
    }),
    _hoisted_7,
    _createVNode(_component_ion_button, { class: "pfBtn-secondary" }, {
      default: _withCtx(() => [
        _createTextVNode("Whatsapp")
      ]),
      _: 1
    })
  ]))
}